import {GraphObject, Panel, Shape, Binding, Point, Geometry, PathFigure, PathSegment} from 'gojs';

import {impactScoreColor} from 'src/util/impact-score';
import {APPLICATION_GRAPH_NODE_RADIUS} from 'src/util/gojs/constants';
import {
  COLOR_EXTRACTED_58,
  COLOR_EXTRACTED_VALUES_86,
} from 'src/styles/colors';

const PARTIAL_COLOR_VALUE = `rgba(${COLOR_EXTRACTED_VALUES_86.join(',')}`;

const {make} = GraphObject;

const HIGHLIGHT_COLOR = `${PARTIAL_COLOR_VALUE}, 0.333)`;
const SELECTED_COLOR = `${PARTIAL_COLOR_VALUE}, 0.8)`;
const BORDER_COLOR = 'transparent';

const ARC_THICKNESS_RATIO = 0.05;
const NODE_STROKE_WIDTH = 2;


export const makeNodeShape = () => {
  const diameter = APPLICATION_GRAPH_NODE_RADIUS * 2;
  const strokeOffset = NODE_STROKE_WIDTH;
  const arcDiameter = diameter - strokeOffset;

  const innerDiameter = arcDiameter - (arcDiameter * ARC_THICKNESS_RATIO);
  const innerOffset = (diameter - innerDiameter + strokeOffset) / 2;

  return make(
      Panel,
      'Position',
      {},
      make(
          Shape,
          'Circle',
          {
            name: 'SHAPE',
            height: diameter,
            width: diameter,
            strokeWidth: NODE_STROKE_WIDTH,
            stroke: 'transparent',
            fill: 'transparent',
          },
          new Binding('stroke', '', ({isHighlighted, isSelected}) => {
            if (isHighlighted) {
              return HIGHLIGHT_COLOR;
            } else if (isSelected) {
              return SELECTED_COLOR;
            } else {
              return BORDER_COLOR;
            }
          }).ofObject(),
      ),
      make(
          Shape,
          'Arc',
          {
            position: new Point(strokeOffset, strokeOffset),
            height: arcDiameter,
            width: arcDiameter,
            strokeWidth: 0,
          },
          new Binding('parameter1', '', ({data}) => data.data.properties['codelogic.quality.impactScore']).ofObject(),
          new Binding('fill', '', ({data}) => {
            const score = data.data.properties['codelogic.quality.impactScore'];
            if (typeof score !== 'number') {
              return COLOR_EXTRACTED_58;
            }
            return impactScoreColor(score);
          }).ofObject(),
      ),
      make(
          Shape,
          'Circle',
          {
            position: new Point(innerOffset, innerOffset),
            height: innerDiameter,
            width: innerDiameter,
            strokeWidth: 0,
            fill: 'white',
          },
          new Binding('stroke', '', ({isHighlighted, isSelected}) => (isHighlighted || isSelected) ? HIGHLIGHT_COLOR : BORDER_COLOR).ofObject(),
      ),
  );
};

Shape.defineFigureGenerator('Arc', function(shape, w, h) {
  let score: undefined | number = undefined;

  if (shape !== null) {
    const param1 = shape.parameter1;
    if (!isNaN(param1) && param1 >= 0) {
      score = param1;
    }
  }

  const geo = new Geometry();
  if (typeof score !== 'number') {
    return geo;
  }

  const offset = 90;
  const sweep = 360 * score;

  geo
      .add(new PathFigure(w / 2, h / 2)
          .add(new PathSegment(PathSegment.Arc, offset, sweep, w / 2, h / 2, w / 2, h / 2)));
  return geo;
});
